import { render, staticRenderFns } from "./VTextField.vue?vue&type=template&id=a61594b0&scoped=true"
import script from "./VTextField.vue?vue&type=script&lang=js"
export * from "./VTextField.vue?vue&type=script&lang=js"
import style0 from "./VTextField.vue?vue&type=style&index=0&id=a61594b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61594b0",
  null
  
)

export default component.exports